export default __webpack_public_path__ + "static/media/starpercent_icon.888537f0.svg";